import React from 'react'
import { object } from 'prop-types'

import ArticleShare from '@/component/Primitive/ArticleShare'

const ArticleLayoutShareWidget = ({ article, pageData }) => {
  if (!article) return null
  const url = encodeURI(pageData?.url)
  return <ArticleShare url={url} />
}

ArticleLayoutShareWidget.propTypes = {
  article: object,
  pageData: object
}

export default ArticleLayoutShareWidget
